<template>
  <!-- 遊客年齡比例 -->
  <div class="col">
    <div class="card card-clean h-100">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        遊客年齡比例
      </div>
      <div class="card-body p-2">
        <div class="d-flex justify-content-end">
          <button  class="btn btn-dia " style="" @click="showModal()" v-if="!isShortView">
            <i class="fas fa-search-plus"></i>
          </button>
        </div>
        <div style="margin:auto;max-width:450px" class="mb-3" id="chart">
          <apexchart
          type="pie"
          :options="chartOptions"
          :series="series"
          ref="chart"
          >
        </apexchart>
      </div>
      <dialog-modal  id="modalPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
          :isImage="false" :isMarginAuto="false" :modalTitle="'遊客年齡比例'" :closeButton="false" >
          <div class="object-detection-detail w-75 m-auto"  id="chartPop">
              <apexchart
                type="pie"
                ref="chartPop"
                :options="chartOptions"
                :series="series"
              ></apexchart>
          </div>
        </dialog-modal>
      <div class="chart-description chart-description-btm">
        當日遊客中心遊客的年齡比例（屬性攝影機）。
      </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "../../components/DialogModal.vue";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
const zh_tw=require('../../utils/apexchartObject/apexLocales/zh-tw.json')


export default {
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  props: {
    selectedScenicAreaId: {
      type: Number,
 
    },
  },

  data() {
    return {
      dataInterval: null,
      peopleAttributeListData: [],
      viewPort: window.innerWidth,
      isShortView:false,
      //  測試非空值時間資料 (上機前須更改)
      startTime: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      endTime: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      // startTime: "2022-12-16T00:00:00",
      // endTime: "2022-12-16T23:55:55",

      //VueApexCharts Setting
      series: [],
      chartOptions: {
        colors: CONST.APEXCHART_COLOR.LINE_CHART_RANGE_FIVE,
        // colors: CONST.APEXCHART_COLOR.SCENIC_AREA,
        chart: {
          type: "pie",
          defaultLocale:'zh-tw',
          locales:[zh_tw],
          // height: 180,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
            export: {
              svg: { filename: undefined },
              png: { filename: undefined },
              csv: { filename: undefined },
            },
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          },
        },
        dataLabels: {
          enabled: true,
          
        },
        states: {
          hover: {
            filter: {
            type: 'none',
            }
          },
          active: {
            allowMultipleDataPointsSelection: true,
            filter: {
              type: "none",
              value: 0,
            },
          },
        },
        labels: [],
        
        legend: {
          // fontSize: "13px",
          // width: 120,
          // position:"left"
        },

        responsive: [
            {
                breakpoint:1280,
                options: {
                  chart: {
                    width: "100%",
                  },
                  legend: {
                    width:120,
                     position:"left"
                   
                  }
                }
              },
            {
                breakpoint: 380,
                options: {
                  chart: {
                    width: "100%",
                  },
                  legend: {
                    position: "bottom",
                    width:"100%"
                   
                  }
                }
              }
        ],
        tooltip: {
       enabled: false,
        },
      },
    };
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    async getPeopleAttributeListPerDay() {
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId: this.selectedScenicAreaId,
      };
      await this.$store.dispatch(
        "peopleAttribute/getPeopleAttributeListPerDay",
        condition
      );
      this.peopleAttributeListData =
        this.$store.getters["peopleAttribute/getSearchAgePerDay"];
      // console.log("get", this.peopleAttributeListData);
    },



    initAgeDataPerHour() {

      this.chartOptions.chart.toolbar.export.svg.filename = `${Utils.getSingleScenicAreaNamebyId(this.selectedScenicAreaId)}_遊客年齡比例_${moment().format(
        "YYYY年MM月DD日_HH時mm分"
      )}`;
      this.chartOptions.chart.toolbar.export.csv.filename = `${Utils.getSingleScenicAreaNamebyId(this.selectedScenicAreaId)}遊客年齡比例_${moment().format(
        "YYYY年MM月DD日_HH時mm分"
      )}`;
      this.chartOptions.chart.toolbar.export.png.filename = `${Utils.getSingleScenicAreaNamebyId(this.selectedScenicAreaId)}遊客年齡比例_${moment().format(
        "YYYY年MM月DD日_HH時mm分"
      )}`;
      this.chartOptions.labels = Object.values(CONST.AGE_LABEL);
      // 若 peopleAttributeListData 都為0人，則自訂 dataLabels 與 tooltip 的值
      if (
        this.peopleAttributeListData[0].childCount === 0 &&
        this.peopleAttributeListData[0].adultCount === 0 &&
        this.peopleAttributeListData[0].eldersCount === 0
      ) {
        this.series = [20, 20, 20];
        this.chartOptions.dataLabels.formatter = function (val, opts) {
          return "0";
        };
        // this.chartOptions.tooltip.y.formatter = function (val) {
        //   return "0 人";
        // };
        this.$refs.chart.updateOptions(this.chartOptions);
        this.$refs.chartPop.updateOptions(this.chartOptions);

      } else {
        const a = [];
        this.peopleAttributeListData.forEach((item) => {
          a.push([item.childCount, item.adultCount, item.eldersCount]);
        });
        this.series = a[0];

        this.chartOptions.dataLabels.formatter = function (val, opts) {
          return Math.round(Number(val)) + "%";
        };
        // this.chartOptions.tooltip.y.formatter = function (val, opts) {
        //   return val + "人";
        // };
        this.$refs.chart.updateOptions(this.chartOptions);
        this.$refs.chartPop.updateOptions(this.chartOptions);

      }
    },
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
  },

  watch: {
    selectedScenicAreaId: {
      // async handler(newVal) {
      //   await this.getPeopleAttributeListPerDay();
      //   this.initAgeDataPerHour();
      // },
      // immediate: true,

      async handler(newVal) {
        if (newVal === null) {
          return;
        }

        await this.getPeopleAttributeListPerDay();
        this.initAgeDataPerHour();
      }, immediate: true,
    },

    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },
  },

  async mounted() {
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);

    this.dataInterval = setInterval(async () => {
      await this.getPeopleAttributeListPerDay();
      this.initAgeDataPerHour();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },

  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>
